$(document).ready(function () {
    $.ajax({
        type: "GET",
        url: "/products/whole-house-water-filter-wd-whf21-fg.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(0)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(0)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $.ajax({
        type: "GET",
        url: "/products/waterdrop-whf21-pg-5-micron-2-stage-wholehouse-water-filtration-system.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(1)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(1)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $.ajax({
        type: "GET",
        url: "/products/whole-house-water-filters/products/spin-down-sediment-filter-wd-pfk.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(2)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(2)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $(window).on("scroll", function () {
        var scrollTop = $(this).scrollTop();
        var offsetTop = $(".wd-compare-content").offset().top;
        if (scrollTop > offsetTop) {
            $(".wd-compare-header").css("display", "block");
        } else {
            $(".wd-compare-header").css("display", "none");
        }
    });

    var wd_compare_index;
    var pre_index;

    var window_width = $(window).width();
    if (window_width <= 1024) {
        $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
            .eq(0)
            .find(".wd-compare-detail-item-product-choose-card-item")
            .eq(2)
            .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
        $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
            .eq(1)
            .find(".wd-compare-detail-item-product-choose-card-item")
            .eq(2)
            .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
    }

    $(".wd-compare-detail-item-product-choose-select").click(function () {
        wd_compare_index = $(this).parents(".wd-compare-detail-item").index();
        pre_index = $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .find(`.wd-compare-detail-item-product-choose-card-item-active`)
            .attr("data-index");

        if (window_width <= 767) {
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "block"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "flex"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "block"
            );
            $("html").css("overflow", "hidden");
            $(".wd-compare").css("z-index", "99");
            $(this)
                .siblings(".wd-compare-detail-item-product-choose-select-mobile")
                .css("border-bottom", "1px solid #2179CA");
            $(this)
                .parents(".wd-compare-detail-item")
                .siblings()
                .find(".wd-compare-detail-item-product-choose-select-mobile")
                .css("border-bottom", "1px solid #e2e2e2");
        }
        $(this)
            .parents(".wd-compare-detail-items")
            .find(".wd-compare-detail-item-product-choose-card")
            .stop()
            .slideUp();
        $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .stop()
            .slideDown();
    });

    $(
        ".wd-compare-detail-item-product-choose-select.wd-compare-detail-item-product-choose-select-mobile"
    ).click(function () {
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-card")
            .css("display", "none");
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-select-mobile")
            .css("border-bottom", "1px solid #e2e2e2");
        $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .css("display", "block");
        $(this).css("border-bottom", "1px solid #2179CA");
    });

    $(".wd-compare-detail-item-product-choose-card").mouseleave(function () {
        $(this).stop().slideUp();
    });
    $(".wd-compare-detail-item-product-choose-card-item").hover(
        function () {
            $(this).addClass("wd-compare-detail-item-product-choose-card-item-hover");
        },
        function () {
            $(this).removeClass(
                "wd-compare-detail-item-product-choose-card-item-hover"
            );
        }
    );
    $(".wd-compare-detail-item-product-choose-card-popup-close").click(
        function () {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "none"
            );
            $("html").css("overflow", "auto");
            $(".wd-compare").css("z-index", "auto");
        }
    );

    $(".wd-compare-detail-item-product-choose-card-item").click(function () {
        if (
            $(this).hasClass(
                "wd-compare-detail-item-product-choose-card-item-choosed"
            )
        ) {
            return false;
        }
        if (window_width <= 1024) {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare").css("z-index", "auto");
        }
        if (window_width <= 767) {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "none"
            );
            $("html").css("overflow", "auto");
        }

        var data_index = $(this).attr("data-index");
        if (data_index !== pre_index) {
            $(".wd-compare-detail-item-product-choose-card-items")
                .find(`[data-index="${pre_index}"]`)
                .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
            pre_index = data_index;
        }
        $(this)
            .siblings()
            .removeClass("wd-compare-detail-item-product-choose-card-item-active");
        $(this).addClass("wd-compare-detail-item-product-choose-card-item-active");
        $(this).removeClass(
            "wd-compare-detail-item-product-choose-card-item-choosed"
        );
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-card-item")
            .each(function () {
                if ($(this).attr("data-index") === data_index) {
                    $(this).addClass(
                        "wd-compare-detail-item-product-choose-card-item-choosed"
                    );
                }
            });

        var product_title = $(this)
            .find(".wd-compare-detail-item-product-choose-card-item-title")
            .html()
            .trim();

        $(this)
            .parents(".wd-compare-detail-item-product-choose")
            .find(
                ".wd-compare-detail-item-product-choose-select .wd-compare-detail-item-product-choose-name"
            )
            .html(product_title);

        $(this)
            .parents(".wd-compare")
            .find(".wd-compare-header-item")
            .eq(wd_compare_index)
            .find(".wd-compare-header-item-title")
            .html(product_title);
        var product_value = $(this).data("value");
        $.ajax({
            type: "GET",
            url: "/products/" + product_value + ".js",
            dataType: "json",
            success: function (product) {
                var goods_price = (product.price_max / 100).toFixed(2);
                var goods_url = product.url;
                $(".wd-compare-product .wd-compare-detail-item")
                    .eq(wd_compare_index)
                    .find(".wd-compare-detail-item-product-price")
                    .html("$" + goods_price);
                $(".wd-compare-header .wd-compare-header-item")
                    .eq(wd_compare_index)
                    .find(".wd-compare-header-item-price")
                    .html("$" + goods_price);
            },
        });

        edit_info(product_title);
    });

    function edit_info(title) {
        if (title == "WHF21-FG") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/5_557a4315-67d8-4411-b5d3-a411f57f8b56.png?v=1679378390"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/5_557a4315-67d8-4411-b5d3-a411f57f8b56.png?v=1679378390"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/whole-house-water-filter-wd-whf21-fg"
                );
            $(".wd-compare-detail-accessories .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834"
                                  alt="">
                          </div>
          `);
            $(".wd-compare-detail-test .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            100,000 water hammer tests and 300 psi pressure tests
                          </div>`
                );

            $(".wd-compare-detail-filtration_accuracy .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            5 microns
        </div>
            `
                );
            $(".wd-compare-detail-water_pressure_delivered .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Up to 15GPM
    </div>
          `);
            $(".wd-compare-detail-recommended .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Well water & Tap water
                          </div>
            `
                );
            $(".wd-compare-detail-connection .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            1“MNPT，3/4”MNPT，3/4“FNPT and 3/4” push-fit plumbing fitting
                          </div>
            `
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
          <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
              alt="">
      </div>
      <div class="wd-compare-detail-item-text">
          14.37"L x 7.48"W x 15.55"H
      </div>
      `);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-text">
          19.33 pounds
      </div>
          `);
            $(".wd-compare-detail-filter .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-text">
        The iron and manganese reducing filter and GAC filter
    </div>
            `);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-longtext">
        99.3% of iron, 96.3% of manganese, chlorine, and other impurities larger than 5 microns.
    </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-a">
        <a href="https://www.waterdropfilter.com/products/wd-wf10-fg">
            <div class="wd-compare-detail-item-img">
                <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/WD-WF10F.png?v=1724138718"
                    alt="">
            </div>
            <div class="wd-compare-detail-item-text">
                WD-WF10FG
            </div>
            <div class="wd-compare-detail-item-text">
                3-6 months
            </div>
        </a>
    </div>
            `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
          <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
              alt="">
      </div>
      <div class="wd-compare-detail-item-text">
          $139.98
      </div>
              `);
        } else if (title == "WHF21-PG") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-whf21-pg_1.png?v=1652871731"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/ui-wd-whf21-pg_1.png?v=1652871731"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/waterdrop-whf21-pg-5-micron-2-stage-wholehouse-water-filtration-system"
                );
            $(".wd-compare-detail-accessories .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834"
                                  alt="">
                          </div>
          `);

            $(".wd-compare-detail-test .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            100,000+ water hammer tests
                          </div>`
                );

            $(".wd-compare-detail-filtration_accuracy .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            5 microns
        </div>
            `
                );
            $(".wd-compare-detail-water_pressure_delivered .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Up to 15GPM
    </div>
          `);
            $(".wd-compare-detail-recommended .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Well water & Tap water
                          </div>
            `
                );
            $(".wd-compare-detail-connection .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            1“MNPT，3/4”MNPT，3/4“FNPT and 3/4” push-fit plumbing fitting
                          </div>
            `
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
          <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
              alt="">
      </div>
      <div class="wd-compare-detail-item-text">
      14.37"L x 7.48"W x 15.55"H
      </div>
      `);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-text">
          21.6 pounds
      </div>
          `);
            $(".wd-compare-detail-filter .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-text">
        Premium PP Cotton & Granular Activated Carbon
    </div>
            `);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-longtext">
        chlorine, lead, benzene, mercury, peculiar smell, sand, rust, and more
    </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-a">
        <a href="https://www.waterdropfilter.com/products/wholehouse-water-filter-system-wd-wf10pg">
            <div class="wd-compare-detail-item-img">
                <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/WD-WF10PG_9184fb7e-ccfe-4769-98e6-177c4b24dff3.jpg?v=1655363075"
                    alt="">
            </div>
            <div class="wd-compare-detail-item-text">
            WD-WF10PG
            </div>
            <div class="wd-compare-detail-item-text">
                3-6 months
            </div>
        </a>
    </div>
            `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
          <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
              alt="">
      </div>
      <div class="wd-compare-detail-item-text">
      $79.98
      </div>
              `);
        } else if (title == "RPFK") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/WD-RPFK.png?v=1643369054"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/WD-RPFK.png?v=1643369054"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/spin-down-filter-wd-rpfk"
                );
            $(".wd-compare-detail-accessories .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834"
                                  alt="">
                          </div>
          `);
            $(".wd-compare-detail-test .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            up to 600Psi instantaneous burst water pressure
                          </div>`
                );

            $(".wd-compare-detail-filtration_accuracy .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            50-micron
        </div>
            `
                );
            $(".wd-compare-detail-water_pressure_delivered .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Up to 20GPM
    </div>
          `);
            $(".wd-compare-detail-recommended .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Well water & Tap water
                          </div>
            `
                );
            $(".wd-compare-detail-connection .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            1“MNPT，3/4”MNPT，3/4“FNPT and 3/4” push-fit plumbing fitting
                          </div>
            `
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
          <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
              alt="">
      </div>
      <div class="wd-compare-detail-item-text">
      10.12"L x 6.69"W x 3.98"H
      </div>
      `);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-text">
          3.83 pounds
      </div>
          `);
            $(".wd-compare-detail-filter .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-text">
        50-micron 316L molybdenum alloy filter
    </div>
            `);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-longtext">
        rust or small objects
    </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                          </div>
            `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg wd-compare-detail-item-svg-none">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                          </div>
              `);
        } else if (title == "WHF3T-FG") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-WHF3T-FG-zhutu-1-min_533bb957-56cf-4418-bc74-8ed934507afa.jpg?v=1764225359"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-WHF3T-FG-zhutu-1-min_533bb957-56cf-4418-bc74-8ed934507afa.jpg?v=1764225359"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/whole-house-water-filters/products/whole-house-iron-filter-for-well-water-wd-whf3t-fg"
                );
            $(".wd-compare-detail-accessories .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834"
                                  alt="">
                          </div>
          `);
            $(".wd-compare-detail-test .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            100,000 water hammer tests and 300 psi pressure tests
                          </div>`
                );

            $(".wd-compare-detail-filtration_accuracy .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            5 microns
        </div>
            `
                );
            $(".wd-compare-detail-water_pressure_delivered .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Up to 15GPM
    </div>
          `);
            $(".wd-compare-detail-recommended .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Well water & Tap water
                          </div>
            `
                );
            $(".wd-compare-detail-connection .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                          </div>
            `
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
          <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
              alt="">
      </div>
      <div class="wd-compare-detail-item-text">
      22.9"L x 8.46"W x 26.1"H
      </div>
      `);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-text">
          49 Pounds
      </div>
          `);
            $(".wd-compare-detail-filter .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-text">
        The iron and manganese reducing filter and GAC filter
    </div>
            `);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-longtext">
        Effectively reduces 95.9% of iron, 99.7% of manganese, smell and odors, chlorine, sediment, rust, sand
and other large particles impurities
    </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
    <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/collections/whole-house-water-filters/products/replacement-wd-wf20fg-for-wd-whf3t-fg-filter-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/1101_-07.jpg?v=1699391969"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-WF20FG
        </div>
        <div class="wd-compare-detail-item-text">
        3-6 months
        </div>
    </a>
</div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
          alt="">
  </div>
  <div class="wd-compare-detail-item-text">
  $169.99
  </div>
          `);
        } else if (title == "WHF3T-PG") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-WHF3T-PG.png?v=1729668538"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-WHF3T-PG.png?v=1729668538"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/whole-house-water-filters/products/whole-house-water-filter-for-tap-water-wd-whf3t-pg"
                );
            $(".wd-compare-detail-accessories .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834"
                                  alt="">
                          </div>
          `);
            $(".wd-compare-detail-test .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            100,000 water hammer tests and 300 psi pressure tests
                          </div>`
                );

            $(".wd-compare-detail-filtration_accuracy .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            5 microns
        </div>
            `
                );
            $(".wd-compare-detail-water_pressure_delivered .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Up to 15GPM
    </div>
          `);
            $(".wd-compare-detail-recommended .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Well water & Tap water
                          </div>
            `
                );
            $(".wd-compare-detail-connection .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                          </div>
            `
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
          <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
              alt="">
      </div>
      <div class="wd-compare-detail-item-text">
      22.9"L x 16.5"W x 26.1"H
      </div>
      `);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-text">
          42.11 Pounds
      </div>
          `);
            $(".wd-compare-detail-filter .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-text">
        The iron and manganese reducing filter and GAC filter
    </div>
            `);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-longtext">
        Effectively reduces 97.7% of Chlorine,  smell and odors, sediment, rust, sand
and other large particles impurities
    </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
    <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/collections/whole-house-water-filters/products/replacement-wd-wf20pg-for-wd-whf3t-pg-home-filtration-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/1101_-03.jpg?v=1699391998"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-WF20PG
        </div>
        <div class="wd-compare-detail-item-text">
        3-6 months
        </div>
    </a>
</div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
          alt="">
  </div>
  <div class="wd-compare-detail-item-text">
  $99.99
  </div>
          `);
        } else if (title == "BG100") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/BG100.png?v=1734434687"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/BG100.png?v=1734434687"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/whole-house-water-filters/products/whole-house-water-filter-system-bg100"
                );
            $(".wd-compare-detail-accessories .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834"
                                  alt="">
                          </div>
          `);
            $(".wd-compare-detail-test .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            100,000 water hammer tests and 300 psi pressure tests
                          </div>`
                );

            $(".wd-compare-detail-filtration_accuracy .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            5 microns
        </div>
            `
                );
            $(".wd-compare-detail-water_pressure_delivered .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Up to 20GPM
    </div>
          `);
            $(".wd-compare-detail-recommended .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Well water & Tap water
                          </div>
            `
                );
            $(".wd-compare-detail-connection .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
                          </div>
            `
                );
            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-svg">
          <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
              alt="">
      </div>
      <div class="wd-compare-detail-item-text">
      6.9"L x 5.7"W x 15.9"H
      </div>
      `);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
          <div class="wd-compare-detail-item-text">
          2.53 Pounds
      </div>
          `);
            $(".wd-compare-detail-filter .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-text">
        The iron and manganese reducing filter and GAC filter
    </div>
            `);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-longtext">
        Effectively reduces rust, sediment, silt, dirt, sand, large particulates
    </div>
          `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
    <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/whole-house-water-filter-system-replacement-filter-for-wd-bg100">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/BG100-filter-1.png?v=1739345780"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-BG100-BGPP4
        </div>
        <div class="wd-compare-detail-item-text">
        1-3 months
        </div>
    </a>
</div>
        `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(wd_compare_index)
                .html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
          alt="">
  </div>
  <div class="wd-compare-detail-item-text">
  $29.99
  </div>
          `);
        }
    }
});
